import { TEAM_FULL_PAGE_SEARCH_PAGE, TEAM_FULL_PAGE_SEARCH_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const teamsAppGlobalSearchRoute: GlobalHomePageRoute = createGlobalRoute({
	layout: 'home',
	nav4Layout: 'expanded',
	exact: true,
	name: TEAM_FULL_PAGE_SEARCH_PAGE,
	path: TEAM_FULL_PAGE_SEARCH_PATH,
	query: ['text?'],
	subproduct: 'townsquare-people-team-directory',
});
